import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Libre Baskerville:400,400i,700", "Libre Franklin:400,700"]
  }
});
